interface IProps {
    prefix?: string;
    suffix?: string;
    counter: number | string;
    classes?: string;
    dataTestId?: string;
}

export const CountDisplay = (props: IProps) => {
    const { prefix, suffix, dataTestId, counter, classes } = props;

    return (
        <label
            data-testid={dataTestId ?? 'count-display'}
            className={`form-check-label ${classes}`}
        >
            {prefix}
            {counter}
            {suffix}
        </label>
    );
};
